import React from "react";
import "./Search_Post_Modal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Pink_Btn from "../../common_btn/pink_btn/Pink_Btn";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const Search_Post_Modal = ({ setStartDate, setEndDate, ...props }) => {
  const {
    control,
    reset,
    register,
    watch, // ✅ ADD THIS
    handleSubmit,
    formState: { errors },
  } = useForm();

  const countries = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const setFilter = async (filterDate) => {
    setStartDate(filterDate?.startDate);
    setEndDate(filterDate?.endDate);

    props?.onHide();
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="common_modal Search_Post_Modal"
      >
        <Modal.Body>
          <div className="searchpost_div">
            <div className="modal_header">
              <p className="left_text">Search Post by following</p>
              {/* <p className="left_text">Search Post by any one of following</p> */}
              <div
                className="close_img_div"
                onClick={() => {
                  props?.onHide();
                }}
              >
                <img
                  src="/assets/images/icons/close.png"
                  className="close_img"
                />
              </div>
            </div>

            <Form>
              <div className="row">
                {/* <div className="col-lg-12 mb-3">
                  <div className="from-group">
                    <Form.Label>Search by Month</Form.Label>
                    <Controller
                      className="Select_Dropdown_holder"
                      name="country_id"
                      control={control}
                      rules={{ required: "Country is required" }}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.country_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={countries}
                        />
                      )}
                    />
                  </div>
                </div> */}

                {/* <div className="col-lg-6 mb-3">
                  <div className="from-group">
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="date"
                      {...register("startDate", {
                        // required: "First name required",
                      })}

                      placeholder="Enter Date"
                    />

                  </div>
                </div> */}

                <div className="col-lg-6 mb-3">
                  <Form.Group className="gray_input_group">
                    <Form.Label>Start Date</Form.Label>

                    {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Controller
                        name="startDate"
                        control={control}
                        render={({ field }) => (
                          <DatePicker
                            label="Select Start Date"
                            value={field.value ? dayjs(field.value) : null}
                            onChange={(newValue) => {
                              const formattedDate = newValue
                                ? newValue.format("YYYY-MM-DD")
                                : null;
                              field.onChange(formattedDate);
                            }}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                              },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider> */}

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Controller
                        name="startDate"
                        control={control}
                        render={({ field }) => (
                          <DatePicker
                            label="Select Start Date"
                            maxDate={dayjs()}
                            value={field.value ? dayjs(field.value) : null}
                            onChange={(newValue) => {
                              const formattedDate = newValue
                                ? newValue.format("YYYY-MM-DD")
                                : null;
                              field.onChange(formattedDate);
                            }}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                error: !!errors?.dob,
                                helperText: errors?.dob?.message,
                              },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Form.Group>
                </div>

                {/* <div className="col-lg-6 mb-3">
                  <div className="from-group">
                    <Form.Label>End Date</Form.Label>
                    <Form.Control type="date"
                      {...register("endDate", {
                        // required: "First name required",
                      })}
                      placeholder="Enter Date" />
                  </div>
                </div> */}

                <div className="col-lg-6 mb-3">
                  <Form.Group className="gray_input_group">
                    <Form.Label>End Date</Form.Label>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Controller
                        name="endDate"
                        control={control}
                        render={({ field }) => (
                          <DatePicker
                            label="Select End Date"
                            maxDate={dayjs()}
                            value={field.value ? dayjs(field.value) : null}
                            onChange={(newValue) => {
                              const formattedDate = newValue
                                ? newValue.format("YYYY-MM-DD")
                                : null;
                              field.onChange(formattedDate);
                            }}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                error: !!errors?.dob,
                                helperText: errors?.dob?.message,
                              },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>

                    {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Controller
                        name="endDate"
                        control={control}
                        rules={{
                          validate: (value) =>
                            !watch("startDate") ||
                            dayjs(value).isSameOrAfter(
                              dayjs(watch("startDate")),
                            ) ||
                            "End Date must be after Start Date",
                        }}
                        render={({ field }) => (
                          <DatePicker
                            label="Select End Date"
                            minDate={
                              watch("startDate")
                                ? dayjs(watch("startDate"))
                                : undefined
                            }
                            value={field.value ? dayjs(field.value) : null}
                            onChange={(newValue) => {
                              const formattedDate = newValue
                                ? newValue.format("YYYY-MM-DD")
                                : null;
                              field.onChange(formattedDate);
                            }}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                              },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider> */}
                  </Form.Group>
                </div>
              </div>

              <div className="btn_holder">
                <Pink_Btn
                  btnText={"Search"}
                  onClick={handleSubmit(setFilter)}
                />
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Search_Post_Modal;
